export const SERVICE = 'INVOICE'
